const SPECIAL_USES = [
  { value: 'bank', label: 'Primary Bank' },
  { value: 'ap', label: 'A/P' },
  { value: 'ar', label: 'A/R' },
  { value: 'asset_sellers', label: 'Asset Sellers' },
  { value: 'paddle_service', label: 'Paddle Service Expense' },
  { value: 'sales', label: 'Sales' },
  { value: 'undeposited_funds', label: 'Undeposited Funds' },
  { value: 'default_fee_income', label: 'Default Fee Income' },
  { value: 'fees_pending_invoice', label: 'Fees Pending Invoice' },
  { value: 'internal_expense', label: 'Internal Expense' },
  { value: 'processing_fee', label: 'Invoice Processing Fee' },
];

export default SPECIAL_USES;
